import React, { useEffect } from 'react'
import { AutocompleteAjaxSeeker, FlagsIconSeeker } from "@ui-seeker/core"
import { isValidNewOffice } from "Pages/Admin/Users/@signals"

import { object, string } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"
import { BACKEND_APIS } from "@constants"
import useAdminNewOfficeInfo from "Pages/Admin/Users/@hooks/useNewOfficeInfo"
import { Box, Typography } from "@mui/material"

export default function OfficeCountryField() {

	const { country, setCountryInfo } = useAdminNewOfficeInfo("", "country")

	const { errors, isValid } = useValidatorSeeker(
		{ country: country },
		object({
			country: string().required('Must provide a Country')
		})
	)

	useEffect(() => {
		isValidNewOffice.value = { ...isValidNewOffice.peek(), country: isValid }
	}, [isValid])

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/all/options/countries`}
		value={country}
		formatOptionLabel={({ value, label }) => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: .5 }}>
			<FlagsIconSeeker countryName={value}/>
			<Typography>{label}</Typography>
		</Box>}
		label="Office Country"
		placeholder="Office Country"
		onChange={e => setCountryInfo(e.target.value)}
		error={errors?.country}
	/>
}